import React from "react";

function ConfirmEmailSent() {
    return (
        <div className="container">
            <h2 className="pt-xlg pb-xl">Please check your inbox</h2>
            <p className="color--black pb-xl text-center">We just emailed you a link to reset your password. If you didn't receive the email, first check your spam folder and then try again.</p>
        </div>
    );
}

export default ConfirmEmailSent;
